import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import LoadingButton from '@mui/lab/LoadingButton';
import Iconify from 'src/components/iconify';
import { Autocomplete } from '@mui/material';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
// components

// ----------------------------------------------------------------------

type Props = {
  onFilters: (key: string, value:any) => void;
  isLoading: boolean;
};

export default function TableToolbar({
  onFilters,
  isLoading
}: Props) {

  const searchSchema = Yup.object().shape({
    type: Yup.string().required('Chưa chọn tên văn bằng'),
    number: Yup.string().required('Chưa nhập số hiệu'),
    name: Yup.string().required('Chưa nhập họ tên'),
    dob: Yup.string().required('Chưa nhập ngày sinh'),
  });

  const defaultValues = {
    type: '',
    number: '',
    name: '',
    dob: ''
  };

  const methods = useForm({
    resolver: yupResolver(searchSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setValue,
    trigger,
  } = methods;

  const handleChangeType = (value:any) => {
    setValue('type', value);
    trigger('type');
  }

  // const removeWhitespace = (str:any) => str.replace(/\s/g, '');

  const onSubmit = handleSubmit((data) => {
    onFilters('filterParam', data);    
  });

  const certificateTypeList = [
    { label: 'Bằng Cử Nhân', value: '0' },
    { label: 'Bằng Bác Sĩ Y Khoa', value: '1' },
  ]
  
  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Stack
        spacing={2}
        direction={{
          xs: 'column',
          md: 'row',
        }}
          justifyContent="center"
          alignItems="center"
          sx={{ my: 5 }}
        >
        <FormControl sx={{ width: '100%', maxWidth: 1 }}>
          <Stack
            spacing={2}
            direction={{
              xs: 'column',
              md: 'row'
            }}
              justifyContent="center"
              alignItems="top"
            >
              <Autocomplete
                options={certificateTypeList}
                fullWidth
                onChange={(event, value) => handleChangeType(value?.value)}
                renderInput={(params) => (
                  <RHFTextField
                    {...params}
                    name="type"
                    label="Tên văn bằng"
                    placeholder="Chọn tên văn bằng"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
              <RHFTextField name="number" fullWidth variant="outlined" label="Số hiệu" placeholder='Nhập số hiệu' InputLabelProps={{ shrink: true, }} />
              <RHFTextField name="name" fullWidth variant="outlined" label="Họ tên" placeholder='Nhập họ tên' InputLabelProps={{ shrink: true, }} />
              <RHFTextField type='date'  name="dob" fullWidth variant="outlined" label="Ngày sinh" InputLabelProps={{ shrink: true, }} placeholder='Nhập ngày sinh' />
              
              <LoadingButton loading={isLoading} loadingPosition="start" type="submit" sx={{ maxWidth: {md: 130, xs: 1}, width: 1, lineHeight: '54px', height: '54px' }} size="large" variant="contained" color="primary" startIcon={<Iconify sx={{ width: 20}} icon="mingcute:search-line" />}>
                Tìm kiếm
              </LoadingButton>
          </Stack>
          
        </FormControl>

      </Stack>
    </FormProvider>
  );
  
}
